<template>
	<Row class="header-container width-100 flex-align-center flex-justify-space-between px-5 py-4">
		<Row class="flex-align-center">
			<FeatureIconsCard class="feature-card-container mr-2" :flowData="workflow" />
			<Col>
				<h3 class="heavy one-row">{{ workflowTitle }}</h3>
				<h5 class="reg half-opacity">{{ readableFlowType }} {{ flowLocation }}</h5>
			</Col>
		</Row>
		<Col class="version-container flex-centerize ml-2">
			<div class="version-text">V{{ draftVersionNumber }}</div>
		</Col>
	</Row>
</template>
<script>
import WorkflowService from '@/utils/WorkflowService';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import FeatureIconsCard from '@/components/Modules/FeatureIconsCard.vue';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service';
import { getPlacementVersion } from '@/store/modules/placements/modules/versions/getters';
import { getPlacement } from '@/store/modules/placements/getters';
export default {
	name: 'ShareFeatureDialogHeader',
	components: { FeatureIconsCard },
	props: {
		service: { type: Object, default: () => ({}) },
		workflow: { type: Object, default: () => ({}) },
	},
	computed: {
		...mapGettersShorthand({ getServiceBySlug, getPlacement, getPlacementVersion }),
		numOfVersions() {
			return this.workflow?.versions?.length - 1 || 1;
		},
		draftVersionNumber() {
			return WorkflowVersionService.getWorkflowDraftVersionNumber(this.workflow);
		},
		workflowTitle() {
			return this.workflow.workflow_title;
		},
		flowType() {
			return this.workflow.flow_type;
		},
		serviceName() {
			return this.service.service_name || '';
		},
		flowLocation() {
			return WorkflowService.getFlowLocation(this.workflow, this.getServiceBySlug, this.getPlacement, this.getPlacementVersion);
		},
		readableFlowType() {
			return WorkflowService.getReadableFlowType(this.workflow, this.getPlacement, this.getPlacementVersion);
		},
	},
};
</script>
<style scoped lang="scss">
.header-container {
	border-bottom: 1px solid #e7e7ed;
}
.feature-card-container {
	height: 35px;
	min-width: 64px;
	max-width: 64px;
	border-radius: 9px;
	background: #ffffff;
	border: 1px solid #abb2bd6e;
	box-shadow: 0px 1px 2px #80899c4d;
	::v-deep {
		.workflow-icon {
			width: 17px !important;
			height: 17px !important;
		}
		.integration-icon {
			width: 17px !important;
			height: 17px !important;
			margin-left: 10px !important;
		}
	}
}
.half-opacity {
	opacity: 0.5;
}
.version-container {
	height: 22px;
	min-width: 35px;
	padding: 0 11px;
	border-radius: 6px;
	background: #f5f7fa;
	border: 1px solid #d6ddea;
}
.version-text {
	opacity: 0.5;
	font-size: 11px;
	color: #000000;
	font-weight: 300;
}
</style>
